export default {
  ACTIVE: 'ACTIVE',
  NEW: 'NEW',
  INACTIVE: 'INACTIVE',
  UNREGISTERED: 'UNREGISTERED',
  DRAFT: 'DRAFT',
};
